module.exports = __webpack_public_path__ + "web/img/default.c0ee5943.png";